export const faqs = [
  {
    q: "爆料大赛是什么活动，怎么参加？",
    a: "爆料大赛是一档面向网友的趣味爆料内容评选活动。任何人都可以在活动期间浏览入围名单，并为自己喜欢的作品打分投票。投票即打分，分数会实时反映在排名结果页上。",
  },
  {
    q: "我的投票会影响最终排名吗？",
    a: "会。每件作品的最终得分由群众打分汇总而来，采用去掉一个最高分、去掉一个最低分后取平均的方式计算，因此你的每一票都会真实影响榜单。",
  },
  {
    q: "同一件作品可以重复投票吗？",
    a: "在同一轮活动周期内，同一账号对同一件作品只计一次分。重复提交不会叠加，确保分数不被恶意刷高，也让评选结果更公平。",
  },
  {
    q: "入围名单是怎么产生的？",
    a: "所有投稿会先经过人工初审，剔除不符合社区规范、来源不明或含有不友善内容的部分。通过初审的作品才会进入对应分类的入围名单，并开始接受群众打分。",
  },
  {
    q: "排名结果多久刷新一次？",
    a: "群众打分数据会持续更新，排名结果页在每次打开时展示当前最新数据，你也可以在榜单页手动刷新查看最新走势。",
  },
  {
    q: "分类之间的分数可以互相比较吗？",
    a: "不同分类的评分标准和作品风格不同，直接横向比较意义有限。我们建议在分类内部查看排名，同时关注每件作品过去 24 小时的分数走势，这样更能看出谁在真正冲榜。",
  },
  {
    q: "活动结束后榜单会保留吗？",
    a: "每轮活动结束后，最终榜单会归档保留，方便回看当轮的入围作品与最终得分。新一轮活动开启时会重新生成入围名单，旧数据不会被覆盖。",
  },
  {
    q: "发现刷分或违规内容怎么办？",
    a: "如果你发现异常刷分、抄袭或涉及隐私的内容，可以通过站点底部的联系邮箱反馈。我们会在核实后取消该作品的参评资格，并同步调整受影响的排名。",
  },
];

export const votingFaqs = [
  {
    q: "投票需要注册账号吗？",
    a: "浏览入围名单与排名结果无需注册。只有提交打分投票时需要简单登记一个邮箱，用于防止重复投票，邮箱仅用于活动校验，不会用于其他用途。",
  },
  {
    q: "可以给多件作品投票吗？",
    a: "可以。你可以为任意多件入围作品投票，每件作品在当轮只计一次分，不妨把票投给你真正认可的那几件。",
  },
];